/* ============================================================
   LUXURY THEME — interactions
   - scroll-aware header
   - reveal-on-scroll
   - stagger groups
   - magnetic gold buttons
   ============================================================ */

(function () {
  'use strict';

  const prefersReducedMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* --- 1. Scroll-aware body class (drives header glassmorphism) --- */
  const onScroll = () => {
    if (window.scrollY > 24) {
      document.body.classList.add('is-scrolled');
    } else {
      document.body.classList.remove('is-scrolled');
    }
  };
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* --- 2. Reveal-on-scroll using IntersectionObserver --- */
  if (!prefersReducedMotion && 'IntersectionObserver' in window) {
    const revealTargets = [
      '.banner__content',
      '.banner__text',
      '.product__title',
      '.product__info-wrapper',
      '.collection__title',
      '.title-wrapper-with-link',
      '.section-header',
      '.rich-text__wrapper',
      '.image-with-text__content',
      '.image-with-text__media',
      '.multicolumn-card',
      '.card-wrapper',
      '.article-card-wrapper',
      '.email-signup-banner__box',
      '.newsletter__wrapper',
      '.footer-block',
    ].join(',');

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('lux-in-view');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
    );

    const attach = (root = document) => {
      root.querySelectorAll(revealTargets).forEach((el) => {
        if (!el.classList.contains('scroll-trigger')) {
          el.classList.add('scroll-trigger');
        }
        io.observe(el);
      });

      // Auto-stagger product grids, collection lists, multicolumn rows
      root
        .querySelectorAll(
          '.grid--3-col-desktop, .grid--4-col-desktop, .multicolumn-list, .collection-list, .product-grid'
        )
        .forEach((grid) => {
          if (!grid.classList.contains('lux-stagger')) {
            grid.classList.add('lux-stagger');
          }
          io.observe(grid);
        });
    };

    attach();

    // Watch for sections added dynamically (Shopify section rendering API)
    document.addEventListener('shopify:section:load', (e) => {
      if (e.target) attach(e.target);
    });
  } else {
    document
      .querySelectorAll('.scroll-trigger, .lux-stagger')
      .forEach((el) => el.classList.add('lux-in-view'));
  }

  /* --- 3. Magnetic hover on primary gold buttons (desktop only, fine pointer) --- */
  if (
    !prefersReducedMotion &&
    window.matchMedia('(pointer: fine)').matches
  ) {
    const magnetSelector =
      '.banner .button, .product-form__submit, .shopify-payment-button__button--unbranded';
    const strength = 10;

    document.addEventListener('mousemove', (e) => {
      const target = e.target.closest(magnetSelector);
      if (!target) return;
      const rect = target.getBoundingClientRect();
      const cx = rect.left + rect.width / 2;
      const cy = rect.top + rect.height / 2;
      const dx = ((e.clientX - cx) / rect.width) * strength;
      const dy = ((e.clientY - cy) / rect.height) * strength;
      target.style.transform = `translate3d(${dx}px, ${dy - 2}px, 0)`;
    });

    document.addEventListener(
      'mouseleave',
      (e) => {
        const target = e.target?.closest && e.target.closest(magnetSelector);
        if (target) target.style.transform = '';
      },
      true
    );

    document.querySelectorAll(magnetSelector).forEach((btn) => {
      btn.addEventListener('mouseleave', () => {
        btn.style.transform = '';
      });
    });
  }

  /* --- 4. Smooth in-page anchor scrolling --- */
  document.addEventListener('click', (e) => {
    const link = e.target.closest('a[href^="#"]:not([href="#"])');
    if (!link) return;
    const id = link.getAttribute('href').slice(1);
    const target = document.getElementById(id);
    if (target) {
      e.preventDefault();
      target.scrollIntoView({
        behavior: prefersReducedMotion ? 'auto' : 'smooth',
        block: 'start',
      });
    }
  });

  /* --- 5. Subtle parallax on hero banner media (desktop) --- */
  if (!prefersReducedMotion && window.matchMedia('(min-width: 990px)').matches) {
    const heroMedia = document.querySelector(
      'main > .shopify-section:first-of-type .banner__media, main > .shopify-section:first-of-type .image-banner__media'
    );
    if (heroMedia) {
      let raf = null;
      window.addEventListener(
        'scroll',
        () => {
          if (raf) return;
          raf = requestAnimationFrame(() => {
            const offset = Math.min(window.scrollY * 0.18, 80);
            heroMedia.style.transform = `translate3d(0, ${offset}px, 0)`;
            raf = null;
          });
        },
        { passive: true }
      );
    }
  }
})();
